import { CamelCase, camelCase } from 'scule';

export type NormalizeObject<T> = T extends []
  ? []
  : T extends (infer U)[]
    ? T extends [infer First, ...infer Rest]
      ? [NormalizeObject<First>, ...NormalizeObject<Rest>]
      : (NormalizeObject<U>)[]
    : T extends object
      ? {
        [K in keyof T as CamelCase<K & string>]: T[K] extends object
          ? NormalizeObject<T[K]> : T[K];
      }
      : T;

export default function normalizeObject<T>(obj: T): NormalizeObject<T> {
  if (typeof obj !== 'object' || obj === null) {
    return obj as NormalizeObject<T>;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => normalizeObject(item)) as NormalizeObject<T>;
  }

  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = camelCase(key) as keyof NormalizeObject<T>;
    const value = obj[key as keyof T];
    acc[camelKey] = (typeof value === 'object' && value !== null
      ? normalizeObject(value) : value) as
      NormalizeObject<T>[keyof NormalizeObject<T>];
    return acc;
  }, {} as NormalizeObject<T>);
}
